import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useLanguage } from '../contexts/LanguageContext';

const CTAContainer = styled(Box)(({ theme }) => ({
  padding: '120px 0',
  background: theme.palette.mode === 'dark'
    ? 'linear-gradient(135deg, #1E40AF 0%, #059669 100%)'
    : 'linear-gradient(135deg, #2563EB 0%, #10B981 100%)',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'url("https://images.unsplash.com/photo-1648798402842-491733124f1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTAwNDR8MHwxfHNlYXJjaHw0fHx0ZWNobm9sb2d5JTIwYWJzdHJhY3QlMjBuZXR3b3JrJTIwZGlnaXRhbHxlbnwwfDB8fGJsdWV8MTc1OTI3NDg1MXww&ixlib=rb-4.1.0&q=85")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: 0.1,
    mixBlendMode: 'overlay',
  },
}));

const CTAButton = styled(Button)({
  background: '#FFFFFF',
  color: '#2563EB',
  padding: '16px 40px',
  fontSize: '1.1rem',
  fontWeight: 700,
  borderRadius: '12px',
  textTransform: 'none',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: '#F9FAFB',
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.3)',
  },
});

export default function CTASection() {
  const { t } = useLanguage();

  return (
    <CTAContainer component="section" aria-labelledby="cta-heading">
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Stack spacing={4} alignItems="center" textAlign="center">
          <Typography
            id="cta-heading"
            variant="h2"
            component="h2"
            sx={{
              fontWeight: 800,
              color: '#FFFFFF',
              fontSize: { xs: '2rem', md: '3rem' },
            }}
          >
            {t('cta.title')}
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: 'rgba(255, 255, 255, 0.9)',
              maxWidth: 700,
              fontSize: { xs: '1rem', md: '1.2rem' },
              lineHeight: 1.8,
            }}
          >
            {t('cta.subtitle')}
          </Typography>

          <CTAButton
            endIcon={<ArrowForwardIcon />}
            href="#contact"
            size="large"
          >
            {t('cta.button')}
          </CTAButton>
        </Stack>
      </Container>
    </CTAContainer>
  );
}